import { Pipe, PipeTransform, Injectable } from "@angular/core";

import { Customer } from "../models/Customer.model";

@Pipe({
  name: "customerfilter",
  pure: false
})
@Injectable()
export class CustomerFilterPipe implements PipeTransform {
  transform(customerList: Customer[], filter: Customer): Customer[] {
    if (!customerList || !filter) {
      return customerList;
    }
    // filter customerList array, customerList which match and return true will be kept, false will be filtered out
    return customerList.filter((customer: Customer) =>
      this.applyFilter(customer, filter)
    );
  }

  /**
   * Perform the filtering.
   *
   * @param {Customer} customer The customer to compare to the filter.
   * @param {Filter} filter The filter to apply.
   * @return {boolean} True if customer satisfies filters, false if not.
   */
  applyFilter(customer: Customer, filter: Customer): boolean {
    for (const field in filter) {
      if (filter[field]) {
        if (customer[field] && typeof filter[field] === "string") {
          if (
            customer[field].toLowerCase().indexOf(filter[field].toLowerCase()) ===
            -1
          ) {
            return false;
          }
        } else if (typeof filter[field] === "number") {
          if (customer[field] !== filter[field]) {
            return false;
          }
        }

      }
    }
    return true;
  }
}
